import { useRouter } from 'next/router'
import { useGetProjectInfoQuery } from 'apiv2/projects'
import { usePrevilegies } from 'hooks/usePrevilegies'

export const useProjectPermissions = (customSlug = null, queryOptions = {}) => {
  const router = useRouter()

  const projectSlug = customSlug || router.query.projectSlug

  const {
    data: projectInfo,
    isLoading: isProjectInfoLoading,
    isSuccess,
  } = useGetProjectInfoQuery(projectSlug, {
    ...queryOptions,
    skip: !projectSlug || queryOptions.skip,
  })

  const hasActiveProject = !!projectSlug && !!projectInfo

  const { isManager, isAdmin } = usePrevilegies()

  const isManagerOrAdmin = isManager || isAdmin

  const canEditProject = !!projectInfo?.capabilities?.includes('edit_project')
  const canShowDashboard =
    !!projectInfo?.capabilities?.includes('show_dashboard')
  const canEditProjectPerms =
    projectInfo?.capabilities?.includes('edit_project_perms')

  return {
    hasActiveProject,
    isManagerOrAdmin,
    canEditProject,
    canShowDashboard,
    canEditProjectPerms,
    isManager,
    isAdmin,
    projectInfo,
    projectSlug,
    isProjectInfoLoading,
    isSuccess,
  }
}
